// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1zw5U","container":"styles_container__VUKmp","title":"styles_title__BoNHf","wrapper":"styles_wrapper__HSOJE","answer":"styles_answer__2cWyM"};